/* eslint-disable no-unsafe-optional-chaining */
import './MonthlyTableView.scss';
import { Column, ReactGrid, Row } from '@silevis/reactgrid';
import { Box, useMediaQuery } from '@chakra-ui/react';
import { useRef, useEffect, useState, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import PlanPermission from 'container/PlanPermission';
import { getIndicatorDetailTableData, updateDataInput } from 'redux/IndicatorPageSlice';
import {
  FetchBlockOutputs,
  FetchDataInput,
  getBaseScenario,
  getDataInput,
  getPlannerBlock,
} from 'redux/PlannerModeSlice';

import { NewCell } from './NewCell';
import { HeaderCell } from './HeaderCell';
import { YearCell } from './ModfiedYearCell';

export interface Properties {
  refetchRequest: () => void;
  planPermission: boolean;
  currentDriver?: any;
  commonObjects?: any;
  isExpand?: boolean;
  plannerModel?: any;
}

const UnExpandTable = ({
  planPermission,
  commonObjects,
  refetchRequest,
  plannerModel,
}: Properties) => {
  const dispatch: any = useDispatch();
  const [isMobile] = useMediaQuery('(max-width: 1700px)');
  const [isMobile1] = useMediaQuery('(max-width: 1500px)');
  const [isMobile2] = useMediaQuery('(max-width: 1300px)');
  const [isMobile3] = useMediaQuery('(max-width: 1300px)');
  const [isMobile4] = useMediaQuery('(max-width: 700px)');
  const cellWidth = isMobile4
    ? 90
    : isMobile3
    ? 100
    : isMobile2
    ? 120
    : isMobile1
    ? 150
    : isMobile
    ? 200
    : 240;

  const { blockId } = useParams();
  const plannerBlock = useSelector(getPlannerBlock);
  const [count, setCount] = useState(0);
  const containerReference = useRef<HTMLDivElement>(null);
  const indicator: any = useSelector(getIndicatorDetailTableData);
  const [people, setPeople] = useState<any[]>([]);
  const indicatorTableData = useSelector(getIndicatorDetailTableData);
  const baseScenario = useSelector(getBaseScenario);
  const dataInputsValue: any = useSelector(getDataInput);
  const isPercentage = indicator?.data_format.toLowerCase() === 'percentage';

  const timeDimension =
    plannerModel &&
    plannerModel?.dimensions?.find((item: any) => {
      return item?.name.toLowerCase() === 'time';
    });

  const getPeople = (): any => {
    const monthlyData =
      dataInputsValue?.dimensions?.length > 0
        ? dataInputsValue?.toggle_data
        : dataInputsValue?.excel_data;
    if (monthlyData) {
      const data: any = [];

      commonObjects.forEach((year: any, yearIndex: any) => {
        const yearData: any = {
          Year: year,
        };

        monthlyData.columns.forEach((column: any, colIndex: any) => {
          yearData[column] = {
            month: column,
            isEnable: true,
            value: monthlyData.data[yearIndex][colIndex],
          };
        });

        data.push(yearData);
      });
      return data;
    }
    return [];
  };

  const getPeopleData = async () => {
    const data = await getPeople();

    setPeople(data);
  };

  useEffect(() => {
    getPeopleData();
    setCount(count + 1);
    return () => {
      setCount(0);
    };
  }, [indicator, dataInputsValue, indicator?.input[0].type]);
  useEffect(() => {
    getPeopleData();
    setCount(count + 1);
    return () => {
      setCount(0);
    };
  }, [indicator?.input[0].type]);

  const getColumns = (): Column[] => {
    const columns: Column[] = [
      { columnId: 'Year', width: 1 },
      ...indicator?.input_display.columns.map((columnId: any) => ({
        columnId,
        width:
          indicator?.input[0]?.type === 'constant'
            ? cellWidth
            : indicator?.input[0]?.type === 'growth'
            ? 125
            : 80,
      })),
    ];

    return columns;
  };

  const getRows = (): Row[] => {
    const headerRow: Row = {
      rowId: 'header',
      cells: [
        { type: 'header', text: '', className: 'yearCellHidden' },
        ...indicator?.input_display.columns.map((column: any) => ({
          type: 'header',
          text:
            column === 'start_value'
              ? 'Start Value'
              : column.toLowerCase() === 'growth_rate'
              ? 'Growth Rate (%)'
              : column === 'value'
              ? 'Value'
              : column,
        })),
      ],
    };
    const dynamicRows: Row[] = people.map((person: any, index: number) => {
      const cells: any[] = [
        {
          type: 'yearCell',
          text: person.Year.name || '',
          className: 'yearCellHidden',
          nonEditable: true,
        },
        ...getColumns()
          ?.slice(1)
          ?.map((column) => ({
            type: 'newCell',
            className: `${index === 0 && 'border-top'}  ${
              people?.length - 1 === index && 'border-left'
            } ${people?.length - 1 === index && 'border-bottom'} ${
              index === getColumns().length - 2 && 'border-right'
            }`,
            placeholder: 'xxx',
            text: person[column.columnId]?.value ? `${person[column.columnId]?.value}` : '0',
            nonEditable: false,
            format: column.columnId === 'growth_rate' ? false : indicator?.data_format_properties,
            isPercentage: column.columnId === 'growth_rate' ? false : isPercentage,
            show: column.columnId,
          })),
      ];

      return {
        rowId: person.Year,
        height: 30,
        cells,
      };
    });

    return [headerRow, ...dynamicRows];
  };

  const columns = useMemo(() => getColumns(), [people]);

  const rows = useMemo(() => getRows(), [people]);

  const handleChanges = async (changes: any) => {
    const dataInputs: any = [];
    changes.forEach((change: any) => {
      if (indicator?.input[0].type === 'constant') {
        const object = {
          value: change.newCell.text,
        };
        dataInputs.push(object);
      } else if (indicator?.input[0].type === 'growth') {
        const object = {
          [change.columnId]: change.newCell.text,
        };
        dataInputs.push(object);
      } else {
        const object = {
          [timeDimension.id]: `${change.columnId}`,
          value: change.newCell.text,
        };
        dataInputs.push(object);
      }
    });

    const payload: any = {
      indicator_id: indicatorTableData?.id,
      request_body: {
        type: indicator?.input[0].type,
        bulk_input: true,
        dimensions: [],
        data_values: dataInputs,
        scenario_id: baseScenario?.id,
      },
    };
    const fetchIndicatorsData = async () => {
      const idArray = plannerBlock?.dimensions
        .filter((item: any) => item.name !== 'Time')
        .map((item: any) => item.id);
      const dimensionIds = idArray.join(', ');
      const payload1 = {
        blockId,
        params: {
          dim_id: dimensionIds,
          indicator_filter: 'all',
          scenario_id: baseScenario?.id,
        },
      };
      dispatch(FetchBlockOutputs(payload1));
    };

    await dispatch(updateDataInput(payload)).then(async () => {
      await dispatch(
        FetchDataInput({
          indicator_id: indicatorTableData?.id,
          parameters: {
            scenario_id: baseScenario?.id,
            format_excel_data: true,
          },
        }),
      );
      await fetchIndicatorsData();
      refetchRequest();
    });
  };

  return (
    <Box
      className='monthly-tableview-container-excel'
      ref={containerReference}
      cursor={planPermission ? 'not-allowed' : 'pointer'}
      overflow={rows.length > 6 ? 'auto' : 'initial'}
    >
      {rows?.length && columns?.length && (
        <ReactGrid
          key={count}
          enableFillHandle
          enableRangeSelection
          stickyTopRows={1}
          rows={rows}
          enableColumnSelection
          columns={columns}
          onCellsChanged={planPermission ? undefined : handleChanges}
          customCellTemplates={{
            newCell: new NewCell(),
            header: new HeaderCell(),
            yearCell: new YearCell(),
          }}
        />
      )}
    </Box>
  );
};
export default PlanPermission(UnExpandTable);
